import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter, NavLink} from "react-router-dom"
import axios from 'axios'
import { connectNode } from '../../../../utils/global'
import { loadLocationWithMessage } from '../../../../actions/location'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import PostAddIcon from '@material-ui/icons/PostAdd'
import '../../../../styles/assets/css/admin/list1.css'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import Pagination from '../../../functions/pagination'
import { filter_patient_status } from '../variables/patient_1.js'
import Spinner from 'react-spinner-material'

import AppBar from '@material-ui/core/AppBar'
import Tab from '@material-ui/core/Tab'
import TabContext from '@material-ui/lab/TabContext'
import TabList from '@material-ui/lab/TabList'
import TabPanel from '@material-ui/lab/TabPanel'


class Summary extends Component {
  constructor() {
      super();
      this.state = {
        status: false,
        message: '',
        tab_status: '1',
        dataItems: [],
      }
      this.onChangePage = this.onChangePage.bind(this)
  }

  componentDidMount() {
    this.getDataList()
  }

  getDataList = () => {
    axios({
      method: 'post',
      url: connectNode + 'admin/patient/get_summary_by_clinician2',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        show_filter_status: this.state.show_filter_status,
        uid: this.props.authReducer.uid,
        user_role: this.props.authReducer.role,
      }
    })
    .then((result) => {
        var val = []
        if(result['data'].length > 0) {
          val = result['data']
        }
        this.setState({
          dataItems: val,
        })
      }
    )

  }

  handleTabChange = (event, newValue) => {
    this.setState({
      tab_status: newValue,
    })
  }

  onChangePage(pageOfItems) {
    this.setState({ pageOfItems: pageOfItems })
  }

  render() {
    return (
      <div className="patient_dashboard box_border4">
        <div className="row">
          <div className="small-12 medium-12 columns headerPage1">
            Summary
          </div>
        </div>
        <div className="row">
          <div className="small-12 columns tab_data1 main_tab">
          <table className="table_data1">
            <thead className="table_head">
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Clinician/PN</th>
                <th>Status</th>
                <th>Registration</th>
                <th>SCID</th>
                <th>Baseline assessments</th>
                <th>Patient contract</th>
                <th>Assessments</th>
                <th>Current step</th>
              </tr>
            </thead>
            <tbody>
            {this.state && this.state.dataItems.map(item =>
              <tr>
                <td>{item.uid}</td>
                <td>{item.fullname}</td>
                <td>{item.c_name} / {item.pn_name}</td>
                <td>{item.p_status}</td>
                <td>{(item.reg_step=='complete_registration' && 'Completed')
                  || (item.reg_step!='complete_registration' && item.reg_step)}</td>
                <td>
                  {(item.mini_bd_result==1 && 'Eligible') || (item.scid_bd_result==1 && 'Eligible')
                  || (item.scid_v1_bd_result==1 && 'Eligible')}
                  {(item.mini_bd_result==2 && 'Ineligible') || (item.scid_bd_result==2 && 'Inligible')
                  || (item.scid_v1_bd_result==2 && 'Ineligible')}
                  {(item.mini_bd_result==null && item.scid_bd_result==null && item.scid_v1_bd_result==null && 'Pending')}</td>
                <td>{(item.baseline_step=='complete_baseline' && 'Completed')
                  || (item.baseline_step!='complete_baseline' && item.baseline_step)}</td>
                <td>{(item.patient_submit_status == 2 && item.progress != 2) && 'Patient signed'}
                    {(item.patient_submit_status != 2 && item.progress != 2 ) && 'Pending'}
                    {item.progress == 2 && 'Completed'}</td>
                <td><a href={"/admin/patient_chart/"+item.uid+"/5/2"}>Assessments</a></td>
                <td>{item.progress}</td>
              </tr>)}
            </tbody>
          </table>
          </div>
          <div className="small-12 columns ">
            <div className="bold">Note:</div>
            <ul>
              <li>Registration pending: Did not complete registration</li>
              <li>Registered: Completed registration</li>
              <li>Active: Completed MINI (Eligible)</li>
              <li>Ineligible: Completed MINI (Ineligible)</li>
              <li>Withdrawn: Completed registration and withdrew / Completed MINI and withdrew / Start treatment and withdrew</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  //console.log('PatientList STATE: ', state)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('PatientList mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(Summary)
